import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';

import styles from './unusualOptions.module.scss';
import './datepicker-mobile.css';
import { ShareButtons } from '@benzinga/ui';

const { RangePicker } = DatePicker;

interface OptionsFilterProps {
  dateRangeValue?: [Dayjs, Dayjs];
  onDateChange: (dates: [Dayjs, Dayjs] | null, dateStrings: [string, string]) => void;
  symbol?: string;
}
const OptionsFilter = ({ dateRangeValue, onDateChange, symbol }: OptionsFilterProps) => {
  return (
    <div className={styles.filterContainer}>
      <div className={styles.filters}>
        <RangePicker
          className={styles.dateRangePicker}
          onChange={(dates, dateStrings) => onDateChange(dates as [Dayjs, Dayjs] | null, dateStrings)}
          value={dateRangeValue}
        />
      </div>
      <div className={styles.socialIcons}>
        <ShareButtons
          buttonLocation="quote_unusual_options"
          buttonStyle={{
            bgStyle: {
              border: '1px solid rgba(63, 131, 248, 0.1)',
              fill: '#3f83f81a',
            },
            borderRadius: 4,
            iconFillColor: '#3F83F8',
            size: 32,
          }}
          className="flex"
          showButtons={['linkedin', 'twitter', 'facebook']}
          url={`https://www.benzinga.com/quote/${symbol}/unusual-options`}
        />
      </div>
    </div>
  );
};

export default OptionsFilter;
